import { Helmet } from 'react-helmet-async';

import { observer } from 'mobx-react-lite';

import Container from '@mui/material/Container';
import { Grid } from '@mui/material';

import Footer from 'src/components/Commons/Footer';
import { TBreadCrumb } from 'src/types/Breakcrumbs/breadcrumb.model';
import BreakCrumbs from 'src/pages/Breakcum';
import { PathURL } from 'src/utils/constants/path';
import useLanguage from 'src/hooks/Language/useLanguage';
import PageHeader from 'src/components/Reports/PageMessageStatistic/PageHeader';
import usePageMessageStatistic from 'src/hooks/Reports/usePageMessageStatistic';
import PageMessageStatisticTable from 'src/components/Reports/PageMessageStatistic/Table/PageMessageStatisticTable';

function PageMessageStatistic() {
  const { language } = useLanguage();
  const { handleFindReport, paramsRef } = usePageMessageStatistic();
  const breadcrumb: TBreadCrumb[] = [
    { path: PathURL.dashboard, name: language.dashboard.titleHeader },
    { path: '', name: 'Báo cáo page tin nhắn' }
  ];

  return (
    <>
      <Helmet>
        <title>{language.digitalReportPage.titleHeader}</title>
      </Helmet>

      <Container maxWidth="xl" className="pt-16">
        <Grid container direction="row" justifyContent="center" alignItems="stretch" spacing={2}>
          <Grid item xs={12} md={12}>
            {breadcrumb && <BreakCrumbs breadcrumb={breadcrumb} />}
          </Grid>
        </Grid>
        <div className="flex flex-row flex-wrap mt-4">
          <div className="w-full">
            <PageHeader onFindReport={handleFindReport} isLoading={false} />
            {paramsRef.current && <PageMessageStatisticTable params={paramsRef.current} />}
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
}

export default observer(PageMessageStatistic);
